import { RadioProps as Mui5RadioProps } from '@mui/material/Radio'

import { FC } from 'react'
import { FormControlLabel } from '../form'
import { StyledHelperText } from '../other/common/StyledHelperText'
import { styled } from '../styles'
import { Radio } from './Radio'

const StyledRadioWrapper = styled('span')<Radio3Props>(({ theme, size, color }) => ({
  display: 'flex',
  flexDirection: 'column',
}))

export type Radio3Props = Omit<Mui5RadioProps, 'icon' | 'checkedIcon'> & {
  helperText?: string
}

export const Radio3: FC<Radio3Props> = (props) => {
  let { color, title, id, value, helperText, ...rest } = props
  return (
    <StyledRadioWrapper>
      <FormControlLabel
        label={title}
        key={id}
        value={value}
        control={
          <Radio
            sx={{ padding: 0, marginRight: '8px' }} // Customize padding and margin to fit new design with label
            color={color || 'primary'}
            {...rest}
          />
        }
      />
      {helperText && <StyledHelperText color={color || 'primary'}>{helperText}</StyledHelperText>}
    </StyledRadioWrapper>
  )
}
